const modulePages = [
	{
		id: 'm3-page1',
		isFacilitatorOnly: true,
		title: 'HVORDAN SOVER I?',
		facilitatorText: null,
		icons: [],
		slides: [
			{
				type: 'video', 
				videoType: 'youtube',
				videoId: '8bIsZ7YlMuk',
				text: 'SE VIDEO'
			},
			{
				id: 'm3-slide',
				type: 'image',
				text: 'SLIDE'
			},
			{
				id: 'm3-stem-med-fodderne-1',
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-2',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-3',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-4',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-5',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-6',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-7',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-8',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-9',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-10',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-11',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-12',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-13',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-14',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-15',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-16',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-17',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-18',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-19',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-20',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-21',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-22',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			{
				id: 'm3-stem-med-fodderne-23',
				hideButton: true,
				type: 'image',
				text: 'STEM MED FØDDERNE',
			},
			
		]	
	},
	{
		id: 'm3-page-2',
		isFacilitatorOnly: true,
		title: 'BYG DIN PERFEKTE AFTENRUTINE',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'iderunde',
				type: 'image',
				text: 'IDÉRUNDE'
			},
			{
				id: 'm3-ovelse',
				type: 'image',
				text: 'ØVELSE'
			}
		]
	},
	{
		id: 'm3-page-3',
		isFacilitatorOnly: true,
		title: 'BASALPLAN',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				type: 'video',
				videoType: 'ignite',
				videoLink: 'https://kfs.euvideocdn.com/player/index.html?id=6a425ff3ac55558c81793fe2', 
				text: 'SE VIDEO'
			},
			{
				id: 'basalplan',
				type: 'image',
				text: 'BASALPLAN'
			},
			{
				id: 'm3-ovelse-2',
				type: 'image',
				text: 'ØVELSE'
			},
			{
				id: 'm3-basalboxen',
				type: 'image',
				text: 'BASALBOXEN'
			}
		]
	},
];


export {
	modulePages
};